import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import apiClient from "@/services/apiClient";
import BrandButton from "@/components/ui/BrandButton";
import LanguageSelector from "@/layout/LanguageSelector";
import "@/pages/page.css";
import { AUTH_ISSUER } from "@/config";

function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await apiClient.post(`${AUTH_ISSUER}/otp-login`, {
        email,
      });

      const data = response.data;

      if (data && data.success) {
        navigate("/verify-otp", { state: { email } });
      } else {
        setError(
          data?.message ||
            t(
              "auth.otpResendFailed",
              "Failed to send login code. Please try again.",
            ),
        );
      }
    } catch (err) {
      setError(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          t("common.serverError", "Server error. Please try again."),
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container">
      <main className="content" style={{ marginLeft: 0 }}>
        <div className="d-flex justify-content-end p-3">
          <LanguageSelector />
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-md-5 col-lg-4">
            <div className="card card-radius">
              <div className="card-body">
                <h3 className="text-center mb-2">
                  {t("auth.forgotPasswordTitle", "Forgot Password")}
                </h3>
                <p className="text-center text-muted mb-4">
                  {t(
                    "auth.forgotPasswordPrompt",
                    "Enter your email address and we'll send you a one-time login code.",
                  )}
                </p>
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      {t("auth.emailAddress", "Email Address")}
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      autoComplete="email"
                    />
                  </div>
                  <BrandButton
                    type="submit"
                    className="w-100"
                    disabled={loading}
                  >
                    {loading
                      ? t("auth.sending", "Sending...")
                      : t("auth.sendLoginCode", "Send Login Code")}
                  </BrandButton>
                </form>
                <div className="mt-3 text-center">
                  <Link to="/login">
                    {t("auth.backToLogin", "Back to Login")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ForgotPassword;
